import React, { Suspense } from 'react';

const VMApplicationContainer = React.lazy(() => import('@vm/omega-shared-component-webapp').then(({ StyleLibrary }) => ({ default: StyleLibrary.VMApplicationContainer })));
const Session = React.lazy(() => import('@vm/omega-shared-component-webapp').then(({ Session }) => ({ default: Session })));

import MarketplaceApp from './App';

const LoadingComponent: React.FC = () => null;

const Root: React.FC = () => {
  return (
    <Suspense fallback={LoadingComponent}>
      <VMApplicationContainer>
        <Session>
          <MarketplaceApp />
        </Session>
      </VMApplicationContainer>
    </Suspense>
  );
};

export default Root;
